<template>
    <b-form-group :label="label" label-for="active-period">
        <Select
            id="active-period"
            :state="state"
            :selected="value"
            :options="activePeriodOptions"
            @changeValue="onChange"
            aria-describedby="active-period-feedback"
            :disabled="disabled"
        />
        <b-form-invalid-feedback id="active-period-feedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import api from '@/services/api'
import { getActivePeriods } from '@/lib/periods'
import {
    Select,
    mapperToOption,
    mapperToOptions,
} from '@/views/components/selects'
import { maxBy } from 'lodash'
import { getDateFromStringWithoutTime } from '@/lib/date'

export default {
    name: 'ActivePeriod',
    components: {
        Select,
    },
    props: ['value', 'state', 'disabled', 'label'],
    data() {
        return {
            periods: [],
            activePeriodOptions: [],
        }
    },
    mounted() {
        api.get('/periods', {
            params: {
                sortedBy: 'desc',
                orderBy: 'end_date',
            },
        })
            .then(resp => {
                const {
                    data: { data },
                } = resp
                const periods = getActivePeriods(data)
                this.periods = periods
                const latestPeriod = mapperToOption(
                    this.getLatestPeriod(periods),
                    undefined,
                    'name'
                )
                this.activePeriodOptions = mapperToOptions(
                    periods,
                    undefined,
                    'name'
                )
                this.$emit('update:value', latestPeriod)
                this.emitStartAndEndDate(latestPeriod && latestPeriod.value)
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$emit('ready', true)
            })
    },
    methods: {
        onChange(event) {
            this.$emit('update:value', event)
            this.emitStartAndEndDate(event && event.value)
        },
        emitStartAndEndDate(selectedPeriodId) {
            if (selectedPeriodId) {
                const periods = [...this.periods]
                const selectedPeriod = periods.filter(period => {
                    return period.id == selectedPeriodId
                })[0]
                const { start_date, end_date } = selectedPeriod
                this.$emit(
                    'startDate',
                    getDateFromStringWithoutTime(start_date, 'YYYY-MM-DD')
                )
                this.$emit(
                    'endDate',
                    getDateFromStringWithoutTime(end_date, 'YYYY-MM-DD')
                )
            }
        },
        getLatestPeriod(periods) {
            const period = maxBy(periods, period => {
                return getDateFromStringWithoutTime(
                    period.start_date,
                    'YYYY-MM-DD'
                )
            })
            return period
        },
    },
}
</script>
